import React, { Component } from 'react';
import {
	Dropdown,
	IDropdownOption,
	IDropdownStyles,
} from '@fluentui/react/lib/Dropdown';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import {
	IStackStyles,
	IStackItemStyles,
	IStackTokens,
	Stack,
} from '@fluentui/react/lib/Stack';
import { Text } from '@fluentui/react/lib/Text';
import { TextField, ITextFieldStyles } from '@fluentui/react/lib/TextField';
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import numbro from 'numbro';
import { DetailsList, SelectionMode } from '@fluentui/react/lib/DetailsList';
import { getApprovalHistoryApi } from '../../api';
import { Label } from '@fluentui/react-northstar';

const moment = require('moment');

const stackTokens: IStackTokens = {
	childrenGap: 5,
};

const stackStyles: IStackStyles = {
	root: {
		paddingTop: '1rem',
	},
};

const stackItemStyles: IStackItemStyles = {
	root: {
		flex: 1,
		// alignItems: 'center',
		// background: DefaultPalette.themePrimary,
		// color: DefaultPalette.white,
		// display: 'flex',
		// height: 50,
		// justifyContent: 'center',
	},
};

const verticalStackTokens: IStackTokens = {
	childrenGap: 5,
};

const textFieldSytles: Partial<ITextFieldStyles> = {
	field: {
		color: '#000',
	},
	subComponentStyles: {
		label: {
			root: { fontWeight: 'normal', color: '#484644' },
		},
	},
};

const options: IDropdownOption[] = [
	{ key: 'Ella', text: 'Ella' },
	{ key: 'Candy', text: 'Candy' },
];

const dropdownStyles: Partial<IDropdownStyles> = {
	title: { color: '#484644' },
	label: {
		fontWeight: 'normal',
		color: '#484644',
	},
	subComponentStyles: {
		label: {
			root: { fontWeight: 'normal', color: '#484644' },
		},
		panel: {},
		multiSelectItem: {},
	},
};

const buttonStyle = {
	root: {
		marginLeft: 8,
		border: 'none',
	},
};

export default class RequestDetailPanelNew extends Component<any> {
	closeDetailPanel = () => {
		this.props.onDismiss(false);
	};

	rednerHistory = () => {
		if (this.props.history && this.props.history.length > 0) {
			return (
				<ul>
					{this.props.history.map((v, i) => {
						return (
							<li key={"li_approverHistory" + i}>
								{' '}
								<Stack.Item grow>
									<span style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
										{` ${v.approvalName}`}
									</span>
									<span>
										{' '}
										{`${v.status} - ${moment(v.updatedTime + 'Z').format(
											'YYYY-MM-DD HH:mm:ss'
										)}`}
									</span>
								</Stack.Item>
							</li>
						);
					})}
				</ul>
			);
		}
	};

	renderAddBucketRequest = (detail) => {
		return (
			<>
				<Stack styles={stackStyles} tokens={stackTokens}>
					<Stack.Item grow>
						<span style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
							Type:{' '}
						</span>
						<span>{detail.requestType}</span>
					</Stack.Item>

					<Stack.Item grow>
						<span style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
							Item No.:{' '}
						</span>
						<span>{detail.fromItemNo}</span>
					</Stack.Item>

					<Stack.Item grow>
						<span style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
							Bucket:{' '}
						</span>
						<span>{detail.fromBucketTitle}</span>
					</Stack.Item>

					<Stack.Item grow>
						<span style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
							Year:{' '}
						</span>
						<span>{detail.fromBudgetYear}</span>
					</Stack.Item>

					{/* <Stack.Item grow>
						<span style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
							Q1:{' '}
						</span>
						<span>
							{numbro(detail.fromLiveQ1Value).format({
								thousandSeparated: true,
								mantissa: 2,
							})}
						</span>
					</Stack.Item>

					<Stack.Item grow>
						<span style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
							Q2:{' '}
						</span>
						<span>
							{numbro(detail.fromLiveQ2Value).format({
								thousandSeparated: true,
								mantissa: 2,
							})}
						</span>
					</Stack.Item>

					<Stack.Item grow>
						<span style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
							Q3:{' '}
						</span>
						<span>
							{numbro(detail.fromLiveQ3Value).format({
								thousandSeparated: true,
								mantissa: 2,
							})}
						</span>
					</Stack.Item>

					<Stack.Item grow>
						<span style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
							Q4:{' '}
						</span>
						<span>
							{numbro(detail.fromLiveQ4Value).format({
								thousandSeparated: true,
								mantissa: 2,
							})}
						</span>
					</Stack.Item>

					<Stack.Item grow>
						<span style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
							FY:{' '}
						</span>
						<span>
							{numbro(detail.fromLiveFyValue).format({
								thousandSeparated: true,
								mantissa: 2,
							})}
						</span>
					</Stack.Item> */}

					<Stack.Item grow>
						<span style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
							Status:{' '}
						</span>
						<span>{detail.status}</span>
					</Stack.Item>

					<Stack.Item grow>
						<span style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
							Comments:{' '}
						</span>
						<span>{detail.adjustComments ?? ''}</span>
					</Stack.Item>
				</Stack>
			</>
		);
	};

	renderModifyRequest = (item) => {
		return (
			<>
				<Stack styles={stackStyles} tokens={stackTokens}>
					<Stack.Item grow>
						<span style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
							Type:{' '}
						</span>
						<span>{item.requestType}</span>
					</Stack.Item>

					<Stack.Item grow>
						<span style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
							From Item:{' '}
						</span>
						<span>{item.fromItemNo}</span>
					</Stack.Item>

					<Stack.Item grow>
						<span style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
							From Budget:{' '}
						</span>
						<span>{item.fromBucketTitle}</span>
					</Stack.Item>

					<Stack.Item grow>
						<span style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
							From Year:{' '}
						</span>
						<span>{item.fromBudgetYear}</span>
					</Stack.Item>
				</Stack>

				{this.rednerDestails()}

				<Stack styles={stackStyles} tokens={stackTokens}>
					<Stack.Item grow>
						<span style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
							TotalAmount:{' '}
						</span>
						<span>{item.totalAmount}</span>
					</Stack.Item>
					<Stack.Item grow>
						<span style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
							Status:{' '}
						</span>
						<span>{item.status}</span>
					</Stack.Item>
					<Stack.Item grow>
						<span style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
							Note:{' '}
						</span>
						<span>{item.adjustComments ?? ''}</span>
					</Stack.Item>
				</Stack>
			</>
		);
	};

	rednerDestails = () => {
		if (this.props.groupRequestDestails && this.props.groupRequestDestails.length > 0) {
			return (
				<>
					{this.props.groupRequestDestails.map((v, i) => {
						return (
							<Stack key={"li_groupRequestDestail" + i} styles={stackStyles} tokens={stackTokens}>
								<Stack.Item grow>
									<span style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
										From Quarter:{' '}
									</span>
									<span>{v.fromQuater}</span>
								</Stack.Item>
								<Stack.Item grow>
									<span style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
										To Item:{' '}
									</span>
									<span>{v.toItemNo}</span>
								</Stack.Item>
								<Stack.Item grow>
									<span style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
										To Budget:{' '}
									</span>
									<span>{v.toBucketTitle}</span>
								</Stack.Item>
								<Stack.Item grow>
									<span style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
										To Year:{' '}
									</span>
									<span>{v.toBudgetYear}</span>
								</Stack.Item>
								<Stack.Item grow>
									<span style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
										To Quarter:{' '}
									</span>
									<span>{v.toQuater}</span>
								</Stack.Item>
								<Stack.Item grow>
									<span style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
										Amount:{' '}
									</span>
									<span>{numbro(v.adjustValue).format({
										thousandSeparated: true,
										mantissa: 2,
									})}</span>
								</Stack.Item>
							</Stack>
						);
					})}
				</>
			);
		}
	};

	render() {
		const { detail } = this.props;
		return (
			<>
				<Panel
					isOpen={this.props.isOpen}
					onDismiss={this.closeDetailPanel}
					type={PanelType.medium}
					headerText='Request Details'
					styles={{
						navigation: { backgroundColor: '#f5f5f5' },
						main: {
							backgroundColor: '#f5f5f5',
						},
						commands: { zIndex: '9999' },
					}}
				>
					<Stack tokens={verticalStackTokens}>
						{detail.requestType === 'Add Bucket'
							? this.renderAddBucketRequest(detail)
							: this.renderModifyRequest(detail)}
					</Stack>
					<Stack styles={stackStyles} tokens={stackTokens}>
						<Stack.Item grow className='sub-header'>
							<Text variant={'large'}>Process History</Text>
						</Stack.Item>
						{this.rednerHistory()}
					</Stack>
				</Panel>
			</>
		);
	}
}
